import React, {Component} from 'react';
import './AccountScreen.css';
import PortalScreen from "../PortalScreen";
import SessionHelper from "../../System/SessionHelper";
import RmButton from "../../Common/RmButton";
import axios from 'axios';
import {Redirect} from 'react-router-dom';
import RmField from "../../Forms/RmField";
import ErrorMessage from "../../Common/ErrorMessage";

export default class AccountScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingAcc: false,
            savingAcc: false,
            data: null,
            redirectTo: null,
            email: "",
            password1: "",
            password2: "",
            name: "",
        };
    }

    handleButtonClick() {
        if (this.state.attemptingSignup) {
            return;
        }

        this.submitChange();
    }

    handleNameChange(value) {
        this.setState({
            name: value,
            errorMessage: null
        });
    }

    handleEmailChange(value) {
        this.setState({
            email: value,
            errorMessage: null
        });
    }

    handlePasswordChange(key, value) {
        let setStateObj = {
            errorMessage: null
        };

        let keyName = (key === 1) ? "password1" : "password2";
        setStateObj[keyName] = value;

        this.setState(setStateObj);
    }

    componentDidMount() {
        this.reloadAcc();
    }

    reloadAcc(force) {
        this.setState({
            loadingAcc: true
        });

        SessionHelper.fetch(force)
            .then((data) => {
                this.setState({
                    data: data,
                    email: SessionHelper.userEmail,
                    name: SessionHelper.userName,
                    password: ""
                });
            })
            .then(() => {
                this.setState({
                    loadingAcc: false
                });
            })
    }

    handleLogoutClick() {
        axios.post("/logout")
            .catch(() => { })
            .then(() => {
                this.setState({
                    redirectTo: "/inloggen"
                })
            });
    }

    submitChange() {
        if (this.state.savingAcc || this.state.loadingAcc) {
            return;
        }

        this.setState({
            savingAcc: true,
            errorMessage: null
        });

        let payload = {
            name: this.state.name,
            email: this.state.email,
            password1: this.state.password1,
            password2: this.state.password2
        };

        axios.patch("/my_account", payload)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.setState({
                        errorMessage: "De wijzigingen zijn opgeslagen.",
                        password1: "",
                        password2: ""
                    });
                } else {
                    this.setState({
                        errorMessage: data.message || "Controleer de ingevoerde gegegevens."
                    });
                }
            })
            .catch((err) => {
                console.error('Account patch, caught error:', err);

                this.setState({
                    errorMessage: "Er ging iets mis bij het opslaan van de gegevens. Probeer het opnieuw."
                });
            })
            .then(() => {
                this.setState({
                    savingAcc: false
                });

                this.reloadAcc(true);
            });
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo}/>
        }

        return (
            <PortalScreen tab={"start"} title={"Mijn account"} isLoading={this.state.loadingAcc || this.state.savingAcc}
                          subText={"Persoonlijke instellingen en opties"}>
                <div className={"AccountScreen"}>
                    <div className={"AccountScreen__top-controls"}>
                        <RmButton label={"Uitloggen"} onClick={this.handleLogoutClick.bind(this)}
                                  busy={this.state.loadingAcc || this.state.savingAcc}/>
                    </div>

                    <hr className={"AccountScreen__hr"} />
                    <h1 className={"AccountScreen__settings-title"}>Instellingen wijzigen</h1>
                    <div>
                        <h2 className={"AccountScreen__subtitle"}>Algemene instellingen</h2>
                        <p className={"generic"}>{"Je kunt hier je naam en e-mail adres wijzigen."}</p>
                        <RmField id={"name"} label={"Vul hier uw naam in..."} iconName={"account-outline"}
                                 inputType={"text"} disabled={!!this.state.attemptingSignup}
                                 value={this.state.name} onChange={this.handleNameChange.bind(this)}
                        />
                        <RmField id={"email"} label={"Vul hier uw e-mail adres in..."} iconName={"email-outline"}
                                 inputType={"email"} disabled={!!this.state.attemptingSignup}
                                 value={this.state.email} onChange={this.handleEmailChange.bind(this)}
                        />
                    </div>
                    <div>
                        <h2 className={"AccountScreen__subtitle"}>Wachtwoord wijzigen</h2>
                        <p className={"generic"}>{"Kies een nieuw wachtwoord, of laat deze velden leeg om het huidige wachtwoord te behouden."}</p>
                        <RmField id={"password_new"} label={"Kies een nieuw wachtwoord..."} iconName={"key-variant"}
                                 inputType={"password"} disabled={!!this.state.attemptingSignup}
                                 value={this.state.password1} onChange={this.handlePasswordChange.bind(this, 1)}
                        />
                        <RmField id={"password_confirm"} label={"Bevestig het nieuwe wachtwoord..."} iconName={"key-variant"}
                                 inputType={"password"} disabled={!!this.state.attemptingSignup}
                                 value={this.state.password2} onChange={this.handlePasswordChange.bind(this, 2)}
                        />
                    </div>
                    <div className={"AccountScreen__controls"}>
                        {this.state.errorMessage &&
                        <ErrorMessage message={this.state.errorMessage}/>
                        }
                        <RmButton label={"Wijzigingen opslaan"} onClick={this.handleButtonClick.bind(this)}
                                  busy={this.state.loadingAcc || this.state.savingAcc}/>
                    </div>

                    <hr className={"AccountScreen__hr"} />
                    <h2 className={"AccountScreen__settings-title"}>Mijn gegevens</h2>

                    <h2 className={"AccountScreen__subtitle"}>Inzage</h2>
                    <p className={"generic"}>
                        Onder de AVG heeft u <strong>recht op inzage van uw gegevens</strong>. U kunt een verzoek bij ons indienen om een kopie te ontvangen van alle gegevens die wij over u hebben vastgelegd.<br />
                        <br />
                        U kunt een verzoek voor inzage indienen via ons <a href={"https://www.rememberme.nl/contact"} target={"_blank"}>Contactformulier</a>. Geef daarbij duidelijk aan dat het gaat om een verzoek tot inzage. Alle verzoeken worden in principe binnen één maand verwerkt. Om uw gegevens te beschermen kunnen wij u tijdens dit proces vragen om uw identiteit te bevestigen.
                    </p>

                    <h2 className={"AccountScreen__subtitle"}>Uitschrijven</h2>
                    <p className={"generic"}>
                        Als u geen gebruik meer wilt maken van de planning tools, kunt u ons vragen om uw account en alle vastgelegde gegevens te verwijderen.<br />
                        <br />
                        U kunt een uitschrijving aanvragen via ons <a href={"https://www.rememberme.nl/contact"} target={"_blank"}>Contactformulier</a>. Wanneer wij uw uitschrijving verwerkt hebben, zullen al uw gegevens permanent verwijderd zijn, en heeft u geen toegang meer tot de planning tools.
                    </p>

                </div>
            </PortalScreen>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Portal/Account/AccountScreen.js